var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout cursor-pointer",on:{"click":_vm.logout}},[_c('Icon',{attrs:{"width":20,"height":20,"icon":"logout","color":"#4d4d4d"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('main.header.logOutSection.text')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }